import type { ResponseAnalysis } from '../balancing.types';
import { StatBadge } from './StatBadge';

type Props = {
  response: ResponseAnalysis;
};

export function ResponseRow({ response }: Props) {
  return (
    <div className="flex items-start gap-4 p-3 bg-gray-50 rounded border border-gray-200">
      <div className="flex-1">
        <p className="text-sm text-gray-900 mb-2">{response.text}</p>
        <div className="flex flex-wrap gap-2">
          <StatBadge label="C" value={response.deltas.cash} />
          <StatBadge label="I" value={response.deltas.investments} />
          <StatBadge label="H" value={response.deltas.happiness} />
          {response.hasItem && (
            <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-purple-100 text-purple-700">
              + Item
            </span>
          )}
          {response.hasAchievement && (
            <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-blue-100 text-blue-700">
              + Achievement
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
